import { useEffect } from 'react';
import { makeVar } from '@apollo/client';
import { useReactiveVar } from '@apollo/client/react';
import { Flex, Tag, Typography } from 'antd';

import { CUSTOMER_SEARCH_FIELD } from 'utilities/constants';

const SEARCH_FIELD_MAP = Object.values(CUSTOMER_SEARCH_FIELD).reduce(
  (map, field) => {
    map[field.name] = field;
    return map;
  },
  {},
);

const criteriaTagsVar = makeVar([]);

const initializeCriteriaTags = (criteria = []) => {
  const init = Object.keys(criteria).map((fieldName) => {
    return {
      label: SEARCH_FIELD_MAP[fieldName].label,
      value: criteria[fieldName],
      name: fieldName,
      checked: true,
    };
  });

  criteriaTagsVar(init);
};

const SearchCriteria = ({
  criteria,
  loading = false,
  onRemoveCriteria = () => {},
}) => {
  const criteriaTags = useReactiveVar(criteriaTagsVar);

  useEffect(() => {
    initializeCriteriaTags(criteria);
  }, [criteria]);

  return (
    <Flex
      gap="var(--spacing)"
      style={{
        paddingBottom: 'var(--spacing-sm)',
      }}
    >
      <Typography.Text>Search Criteria:</Typography.Text>
      <Flex gap="var(--spacing)" flex="1">
        {criteriaTags.map((tag) => (
          <Tag
            key={`criteria-${tag.label}`}
            closeIcon={criteriaTags.length > 1}
            onClose={() => {
              !loading && onRemoveCriteria(tag.name);
            }}
          >
            <span>
              {tag.label}: <strong>{tag.value}</strong>
            </span>
          </Tag>
        ))}
      </Flex>
    </Flex>
  );
};

export default SearchCriteria;
